import React from 'react'
import { useIntl } from 'react-intl'
import ProductQuantity from '@molecules/ProductQuantity/ProductQuantity'
import PriceTag from './PriceTag'
import * as T from './CommerceBox.types'

const CommerceBoxMiniCart = ({
  CTAButton,
  innerRef,
  product,
  onDelete,
  onQuantityChange,
  WishlistButton,
  showLowestPrice
}: T.CommerceBoxMiniCartProps) => {
  const { formatMessage } = useIntl()
  const {
    productId,
    price,
    quantity = 1,
    c_basePrice,
    c_minSetPrice,
    currency,
    c_basketLimit,
    c_orderable = true,
    c_isGiftcard = false,
    bonusProductLineItem = false,
    c_lastMonthPrice,
    c_lastMonthPriceCallback,
    priceAdjustments
  } = product

  //calculate priceAfterItemDiscount without Customer Credit adjusment
  const validDiscounts = priceAdjustments?.filter(
    (adjustment) => !adjustment?.promotionId?.startsWith('CustomerCredit-')
  )
  const priceWithDiscounts = validDiscounts?.reduce(
    (acc, current) => acc + current.price,
    price
  )

  return (
    <div
      className='grid min-h-[50px] grid-cols-[150px_auto] items-center'
      ref={innerRef}
    >
      <div className='px-3'>
        {!bonusProductLineItem ? (
          <ProductQuantity
            withDebounce
            productId={productId}
            disabled={!c_orderable || c_isGiftcard || !!product?.type?.set}
            selectedQuantity={quantity}
            limit={c_basketLimit}
            onChange={onQuantityChange}
            width={'w-full'}
          />
        ) : (
          <div className='text-center'>
            {quantity}{' '}
            {formatMessage({
              defaultMessage: 'PCS',
              id: 'msp.commerce_box.bonus_product.quantity.label'
            })}
          </div>
        )}
      </div>
      <div className='flex items-center justify-between space-x-5 px-4'>
        <PriceTag
          discountPrice={priceWithDiscounts}
          c_basePrice={c_basePrice}
          price={c_minSetPrice || price}
          currency={currency}
          showLowestPrice={showLowestPrice}
          lastMonthPrice={c_lastMonthPrice}
          lastMonthPriceCallback={c_lastMonthPriceCallback}
        />
        <div className='flex flex-row items-center justify-between'>
          {WishlistButton && <div className='mr-4'>{WishlistButton}</div>}
          {!bonusProductLineItem ? (
            <div
              className='flex cursor-pointer'
              onClick={() => onDelete && onDelete()}
            >
              {CTAButton}
            </div>
          ) : (
            <div className='min-h-[20px] min-w-[20px] '></div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CommerceBoxMiniCart
